// services/removeFromCartService.js
import { API_END_POINTS } from "../../API_END_POINTS";
import axios from "axios";

// Define the remove from cart API URL, adding the product_id dynamically
const removeFromCartUrl = `${process.env.REACT_APP_API_URL}${API_END_POINTS.removeFromCart}`;

const removeFromCartService = async (product_id) => {
  try {
    const response = await axios.delete(`${removeFromCartUrl}/${product_id}`, {
      headers: {
        authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    });
    return response.data; // Return the response for further handling
  } catch (error) {
    console.error("Error removing product from cart:", error);
    throw error; // Throw the error for rejection in the async thunk or component
  }
};

export { removeFromCartService };
